var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#181a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "182b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#182b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002B64",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    fillRule: "evenodd",
    d: "M0 9.6h9.429V16H0zM12.571 0H22v6.4h-9.429z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.429 9.6H0V6.4h9.429V0h3.142v6.4H22v3.2h-9.429V16H9.43z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007A1B",
    d: "M11 9.598c.868 0 1.572-.716 1.572-1.6 0-.883-.704-1.6-1.572-1.6s-1.571.717-1.571 1.6.703 1.6 1.571 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002B64",
    d: "M11 8.532c.29 0 .524-.24.524-.534A.53.53 0 0 0 11 7.465a.53.53 0 0 0-.524.533c0 .295.235.534.524.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    fillRule: "evenodd",
    d: "M9.953 7.465c.289 0 .523-.239.523-.533a.53.53 0 0 0-.523-.534.53.53 0 0 0-.524.534c0 .294.234.533.524.533m2.095 0c.289 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "181a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagDo = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagDo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";